import { useFormik } from 'formik';
import React, { useEffect, } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { customStyles } from '../../utils/constantVariables';
import { useAddAssignmentMarkMutation } from '../../features/assignmentMarks/assignmentMarksApi';
import useAuth from '../../hooks/useAuth';


Modal.setAppElement('#root');

const validationSchema = Yup.object({
	repo_link: Yup.string().required('Link is required'),
});

function StudentAssignmentForm({ isModalOpen, toggleModal, mainVideo, assignment }) {

	const dispatch = useDispatch();
	const { name: student_name, id: student_id } = useAuth() || {};
	const [addAssignment, { isSuccess: addSuccess, isError: addError, isLoading: addLoading }] = useAddAssignmentMarkMutation();

	const initialValues = {
		repo_link: ''
	}

	//Hooks
	useEffect(() => {
		if (addSuccess) {
			// dispatch(toggleModal(false));
		}
	}, [addSuccess, dispatch])

	const { values, handleBlur, handleChange, handleSubmit, touched, errors } = useFormik({
		initialValues,
		validationSchema,
		onSubmit: async (values, { resetForm }) => {
			const { id, title, totalMark } = assignment || {};
			const payload = { ...values, assignment_id: id, title, createdAt: new Date(), student_id, student_name, totalMark, mark: 0 }
			addAssignment({ data: payload });
			toggleModal();
		},
	});

	//Functions
	const handleModal = () => {
		toggleModal(!isModalOpen);
	}

	return (
		<div>
			<Modal
				isOpen={isModalOpen}
				onRequestClose={handleModal}
				style={customStyles}
			>
				<form onSubmit={handleSubmit}>
					<div>
						<label htmlFor="name">Repository Link:</label>
						<input
							type="text"
							id="repo_link"
							name="repo_link"
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.repo_link}
						/>
						{touched.repo_link && errors.repo_link ? (
							<div className='form-error'>{errors.repo_link}</div>
						) : null}
					</div>
					<div className='form-footer'>
						<button type='close' onClick={handleModal}>
							Close
						</button>
						<button type='submit' disabled={addLoading}>
							Submit
						</button>
					</div>

				</form>
			</Modal>

		</div>
	)
}

export default StudentAssignmentForm